import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../shared/models/apiurl.models";
import {LoadingMaskServiceService} from "../../components/loading-frame/loading-frame.component";
import {AdvService} from "./service/advertisement.service";
import {QuestionBase} from "../../pages/create-adv/models/question-base";

import {OfferProductComponent} from "../../components/offer-product/offer-product.component";

export enum AdvertisementEnum{
  BANNER_ADV="banner_adv",
  ONE_EXPANDED_BANNER="one_expanded_banner",
  SQUARE= "square",
  EXTEND_BANNER = "extend_banner"
}
export interface Advertisement{
  User:number,
  active: boolean,
  description: string,
  expireDate: string,
  heightSize: number,
  highlight: boolean,
  linkAdv?: string,
  id: number,
  image: string,
  image2: string | null;
  mainCategory: string,
  resourcetype: string,
  startDate: string,
  video: string | null,
  withSize: string
}
@Component({
    selector: 'app-advertisement',
    templateUrl: './advertisement.component.html',
    imports: [
    OfferProductComponent
],
    styleUrls: ['./advertisement.component.css']
})
export class AdvertisementComponent implements OnInit {
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }
  constructor(private http: HttpClient, private apiKey:ApiUrl, private advService:AdvService) { }

  advertisementObj: Advertisement[] = [];
  imageLoaded = false;

  @Input()
  advertisementType!: AdvertisementEnum;

  // Lets a parent know once the fetch has resolved and whether there's
  // actually an ad to show — so it can avoid rendering an empty wrapper
  // (with its own margin/min-height) around nothing. Emitted for every
  // type, but only EXTEND_BANNER's parent listens to it today.
  @Output()
  adReady = new EventEmitter<boolean>();

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  ngOnInit(): void {
    if(this.advertisementType == AdvertisementEnum.BANNER_ADV){
      this.advService.getAdvertisement(AdvertisementEnum.BANNER_ADV, 2).subscribe((advertisement:Advertisement[]) =>{
        this.advertisementObj = advertisement;
        this.adReady.emit((advertisement?.length ?? 0) > 0);
      })
    }
    if(this.advertisementType == AdvertisementEnum.SQUARE){
      this.advService.getAdvertisement(AdvertisementEnum. SQUARE, 1).subscribe((advertisement:Advertisement[]) =>{
        this.advertisementObj = advertisement;
        this.adReady.emit((advertisement?.length ?? 0) > 0);
      })
    }
    if(this.advertisementType == AdvertisementEnum.EXTEND_BANNER){
      this.advService.getAdvertisement(AdvertisementEnum. EXTEND_BANNER, 1).subscribe((advertisement:Advertisement[]) =>{
        this.advertisementObj = advertisement;
        this.adReady.emit((advertisement?.length ?? 0) > 0);
      })
    }

  }

  protected readonly AdvertisementEnum = AdvertisementEnum;
}
